import usePartners from "@/features/partners/hooks/use-partners";
import PartnerDiscount from "../components/partner-discount";
import PartnerDiscountDialog from "../components/partner-discount-dialog";

function ProfileMembershipDiscountsPage() {
	const {
		partners,
		selectedPartner,
		onPartnerClicked,
		showPartnerDiscountsModal,
		setShowPartnerDiscountsModal,
	} = usePartners();

	return (
		<div className="flex flex-col gap-8">
			<PartnerDiscountDialog
				showPartnerDiscountsModal={showPartnerDiscountsModal}
				setShowPartnerDiscountsModal={setShowPartnerDiscountsModal}
				selectedPartner={selectedPartner}
			/>
			<p className="web-heading-h3-medium">Membership Discounts</p>
			<div className="grid grid-cols-2 gap-4 md:grid-cols-4">
				{partners.map((partner) => (
					<PartnerDiscount
						key={partner.id}
						partner={partner}
						onPartnerClicked={onPartnerClicked}
					/>
				))}
			</div>
		</div>
	);
}

export default ProfileMembershipDiscountsPage;
